import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SearchArea } from './styled';
import Reveal from '../../components/Reveal';
import FloatingShapes from '../../components/FloatingShapes';
import { WHATSAPP_URL } from '../../components/WhatsAppButton';

const WHATS_NUMBER = '5521984856295';
const EMAIL = 'comercial@salato.com.br';

const channels = [
    {
        key: 'whats',
        icon: require('../../assets/images/whatsApp.png'),
        label: 'WhatsApp',
        value: '(21) 98485-6295',
        hint: 'Resposta mais rápida',
        href: WHATSAPP_URL,
        external: true,
        featured: true,
    },
    {
        key: 'email',
        icon: require('../../assets/images/email.png'),
        label: 'E-mail',
        value: EMAIL,
        hint: 'Propostas e documentos',
        href: `mailto:${EMAIL}`,
        tintIcon: true,
    },
    {
        key: 'insta',
        icon: require('../../assets/images/instagram.png'),
        label: 'Instagram',
        value: '@salato_alimentos',
        hint: 'Novidades e bastidores',
        href: 'https://www.instagram.com/salato_alimentos/',
        external: true,
    },
    {
        key: 'face',
        icon: require('../../assets/images/facebook.png'),
        label: 'Facebook',
        value: '/salatoalimentos',
        hint: 'Acompanhe a Salato',
        href: 'https://www.facebook.com/salatoalimentos',
        external: true,
    },
];

const ASSUNTOS = ['Pedidos', 'Orçamento', 'Fornecedor', 'Representação', 'Dúvidas', 'Sugestões', 'Reclamações'];

const Page = () => {
    const query = new URLSearchParams(useLocation().search);
    const [nome, setNome] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [assunto, setAssunto] = useState(query.get('q') || '');
    const [mensagem, setMensagem] = useState('');
    const [enviado, setEnviado] = useState(false);

    const montarTexto = () => [
        `Olá! Meu nome é ${nome.trim()}${empresa.trim() ? `, da ${empresa.trim()}` : ''}.`,
        assunto ? `Assunto: ${assunto}` : '',
        '',
        mensagem.trim(),
    ].filter((l, i) => l !== '' || i === 2).join('\n');

    const enviarWhats = (e) => {
        e.preventDefault();
        const url = `https://wa.me/${WHATS_NUMBER}?text=${encodeURIComponent(montarTexto())}`;
        window.open(url, '_blank', 'noopener');
        setEnviado(true);
    };

    const enviarEmail = () => {
        const subject = `${assunto || 'Contato pelo site'} — ${nome.trim() || 'Site Salato'}`;
        window.location.href = `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(montarTexto())}`;
        setEnviado(true);
    };

    const podeEnviar = nome.trim() && mensagem.trim();

    return (
        <SearchArea>
            <section className="contactHero">
                <FloatingShapes items={[
                    { shape: 'bolinha', color: '#ffd60a', size: 28, top: '30%', left: '12%' },
                    { shape: 'coxinha', color: '#ec1c24', size: 40, top: '20%', right: '13%', rotate: 16, opacity: .85, delay: 1, hideMobile: true },
                    { shape: 'brilho', color: '#ec1c24', size: 22, bottom: '18%', left: '22%', opacity: .5, delay: .6 },
                    { shape: 'brilho', color: '#ffd60a', size: 30, bottom: '10%', right: '24%', delay: 1.8, hideMobile: true },
                ]} />
                <div className="heroInner" style={{ position: 'relative', zIndex: 1 }}>
                    <span className="sectionTag">Fale com a Salato</span>
                    <h1>Vamos conversar?</h1>
                    <p>
                        Dúvidas, pedidos, orçamentos ou parcerias: escolha o canal que preferir
                        ou mande sua mensagem pelo formulário.
                    </p>
                </div>
            </section>

            <div className="contactGrid">
                <div className="channels">
                    {channels.map((c, i) => (
                        <Reveal key={c.key} delay={i * 70}>
                            <a
                                className={`channelCard${c.featured ? ' featured' : ''}`}
                                href={c.href}
                                {...(c.external ? { target: '_blank', rel: 'noreferrer' } : {})}
                            >
                                <span className="channelIcon">
                                    <img src={c.icon} alt="" width="28" height="28" className={c.tintIcon ? 'tint' : ''} />
                                </span>
                                <span className="channelText">
                                    <small>{c.label}</small>
                                    <strong>{c.value}</strong>
                                    <em>{c.hint}</em>
                                </span>
                                <span className="channelArrow" aria-hidden="true">→</span>
                            </a>
                        </Reveal>
                    ))}

                    <Reveal className="addressCard" delay={300}>
                        <div>
                            <small>Fábrica</small>
                            <strong>Rua Waldemar Colombo Garcia, 491</strong>
                            <span>Condomínio Unidas · Magé/RJ</span>
                        </div>
                        <a
                            href="https://www.google.com/maps/dir/?api=1&destination=Rua%20Waldemar%20Colombo%20Garcia%20491%20Mag%C3%A9%20RJ"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Como chegar →
                        </a>
                    </Reveal>
                </div>

                <Reveal className="formCard" delay={120}>
                    {enviado ? (
                        <div className="formDone">
                            <span className="doneIcon" aria-hidden="true">✓</span>
                            <h2>Mensagem pronta!</h2>
                            <p>
                                Abrimos o WhatsApp ou o seu e-mail com tudo preenchido. É só confirmar o envio por lá.
                            </p>
                            <button type="button" className="ghostButton" onClick={() => setEnviado(false)}>
                                Escrever outra mensagem
                            </button>
                        </div>
                    ) : (
                        <form onSubmit={enviarWhats}>
                            <h2>Envie sua mensagem</h2>
                            <p className="formLead">Preencha e escolha como prefere enviar.</p>

                            <div className="fieldRow">
                                <label className="field">
                                    <span>Seu nome *</span>
                                    <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Como podemos te chamar?" required />
                                </label>
                                <label className="field">
                                    <span>Empresa</span>
                                    <input value={empresa} onChange={(e) => setEmpresa(e.target.value)} placeholder="Opcional" />
                                </label>
                            </div>

                            <div className="field">
                                <span>Assunto</span>
                                <div className="chips" role="radiogroup" aria-label="Assunto">
                                    {ASSUNTOS.map((a) => (
                                        <button
                                            type="button"
                                            key={a}
                                            role="radio"
                                            aria-checked={assunto === a}
                                            className={assunto === a ? 'chip active' : 'chip'}
                                            onClick={() => setAssunto(assunto === a ? '' : a)}
                                        >
                                            {a}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <label className="field">
                                <span>Mensagem *</span>
                                <textarea
                                    value={mensagem}
                                    onChange={(e) => setMensagem(e.target.value)}
                                    placeholder="Conte o que você precisa: produtos, quantidades, cidade de entrega…"
                                    rows={5}
                                    required
                                />
                            </label>

                            <div className="formActions">
                                <button type="submit" className="whatsButton" disabled={!podeEnviar}>
                                    <img src={require('../../assets/images/whatsApp.png')} alt="" width="22" height="22" />
                                    Enviar pelo WhatsApp
                                </button>
                                <button type="button" className="ghostButton" onClick={enviarEmail} disabled={!podeEnviar}>
                                    Enviar por e-mail
                                </button>
                            </div>
                        </form>
                    )}
                </Reveal>
            </div>
        </SearchArea>
    );
};

const mapStateToProps = (state) => ({
    nome: state.user.nome,
});

const mapDispatchToProps = (dispatch) => ({
    setNome: (nome) => dispatch({ type: 'SET_NOME', payload: { nome } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
